import { hexToRgba } from "./color-conversions/hex-to-rgba";
import { hslaToRgba } from "./color-conversions/hsla-to-rgba";
import type { HexColor } from "./hex-color/hex-color";
import type { HSL } from "./hsla-color/hsl-color";
import type { HSLA } from "./hsla-color/hsla-color";
import type { RGB } from "./rgba-color/rgb-color";
import type { RGBA } from "./rgba-color/rgba-color";

const toRgba = (color: HexColor | HSL | HSLA | RGB | RGBA): RGB | RGBA => {
    if (typeof color === "string") return hexToRgba(color);
    if ("red" in color)
        return {
            ...color,
            alpha: "alpha" in color ? color.alpha : 1,
        };
    if ("hue" in color) {
        return hslaToRgba(
            color.hue,
            color.saturation,
            color.light,
            "alpha" in color ? color.alpha : 1,
        );
    }
    throw new Error("Unhandled color type; " + JSON.stringify(color));
};

/**
 * Calculates the luminance of a color.
 * @returns The luminance value.
 */
const calculateLuminance = (
    color: RGB | RGBA | HSL | HSLA | HexColor,
): number => {
    const rgba = toRgba(color);
    const a = [rgba.red, rgba.green, rgba.blue].map(v => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    const luminance = a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    return luminance;
};

export { calculateLuminance };
